import { Technology } from '../technology';


export class TechnologySerializer {
    fromJson(json: any): Technology {
        const data = new Technology();
        data.value = json.id;
        data.label = json.name;
        return data;
    }

    toJson(data: Technology): any {
        return {
            id: data.id,
            name: data.name
        };
    }
}